import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { IdpType } from 'api/account';
import { ReactComponent as Google } from 'components/atoms/vendor-loign/google.svg';
import { Button } from 'components/facade/button';
import { useTranslate } from 'hooks/use-translation';
export const SsoSamlButton = ({ idp, googleSSOHandler, samlFlowHandler, isCognitoEnabled, oktaAuth, idpId })=>{
    const translate = useTranslate();
    return /*#__PURE__*/ _jsx(Button, {
        icon: idp.idpType === IdpType.Google && /*#__PURE__*/ _jsx(Google, {}),
        onClick: ()=>{
            if (isCognitoEnabled) {
                if (idp.idpType === IdpType.Google) {
                    googleSSOHandler();
                } else {
                    samlFlowHandler();
                }
                return;
            }
            if (!oktaAuth) {
                return;
            }
            oktaAuth.signInWithRedirect({
                idp: idpId
            });
        },
        children: idp.idpType === IdpType.Google ? translate('google.sign-in') : translate('sign_in.sso')
    }, idp.idpId);
};
